import { Formik, useFormik } from 'formik'
import React, { useContext, useEffect, useState } from 'react'
import * as Yub from 'yup';
import BaseURL from '../Utilities/BaseUrl';
import axios from 'axios';
import {cartContext}from'../Contexts/CartContext';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function PaymentCredit() {
    let navigate=useNavigate();
    const [loading, setloading] = useState(false);
    const [disab, setdisab] = useState(true);
    let {getCart,setproductsCart,check,setcheck}=useContext(cartContext);
    let validationSchema=Yub.object({
        details:Yub.string().required('Your Address Required'),
        phone:Yub.string().matches(/^(02)?01[0125][0-9]{8}$/,'Please Enter Valid Phone Number').required('Your Phone required'),
        city:Yub.string().required('Your City Required'),
    })
    let formik=useFormik({
        initialValues:{
            shippingAddress:{
                details: "",
                phone: "",
                city: ""
                }
        },
        validationSchema,
        onSubmit:(values)=>{
            axios.post(`${BaseURL}orders/checkout-session/${localStorage.getItem('cartID')}?url=${window.location.origin}`,values,{headers:{token:localStorage.getItem('token')}}).then((data)=>{
               
               
          localStorage.setItem('cartNum',0);
         setloading(true);
         getCart();
         window.location.href=`${data.data.session.url}`;
          
         
         
                    
            }).catch((error)=>{console.log(error);})
        }

    })

  
    
  return <><Helmet>
  <title>PaymentCredit</title>
  
</Helmet>
  
  <div className="container mt-5 pt-5  ">
    <div className="row">
     <div className="AddressDetails">
        <form onSubmit={formik.handleSubmit}>

          <label htmlFor="details ">Address Details :</label>
          <input type="text" onChange={formik.handleChange} onBlur={formik.handleBlur} name="details" id="details" className='form-control  mt-3 mb-3' style={{width:450}} placeholder='Please Enter Your Address' /> 
          {formik.errors.details&&formik.touched.details?<p className='alert alert-danger'>{formik.errors.details}</p>:''}
          <label htmlFor="phone">phone:</label>
          <input type="text" name="phone" onChange={formik.handleChange} onBlur={formik.handleBlur} id="phone" className='form-control  mt-3 mb-3' style={{width:450}} placeholder='Please Enter Your Phone Number' />  
          {formik.errors.phone &&formik.touched.phone?<p className='alert alert-danger'>{formik.errors.phone}</p>:''}
          <label htmlFor="city">city:</label>
          <input type="text" name="city" id="city"onChange={formik.handleChange} onBlur={formik.handleBlur}  className='form-control  mt-3 mb-4' style={{width:450}} placeholder='Please Enter Your city' />
          {formik.errors.city &&formik.touched.city?<p className='alert alert-danger'>{formik.errors.city}</p>:''} 

          <button type='submit' className='btn bg-main text-white' disabled={!(formik.isValid&&formik.dirty&&disab)}>{loading?<span className="spinner-border spinner-border-sm"></span>:'Proceed to orders'}</button> 
        </form>
     </div>
    </div>
  </div>
  </>
}

export default PaymentCredit